import { DepositForm } from "./DepositForm";

export function DepositFormPage() {
  return <DepositForm />;
}
